<script setup>
// T-260 · EXPORTAÇÃO EM TODOS OS RELATÓRIOS.
//
// O uso declarado pelo clube é jogar o arquivo numa IA para analisar. Painel com análise pronta
// ficou para depois, quando souberem o que pedir.
//
// ⚠️ BAIXA O MESMO OBJETO QUE A TELA ESTÁ MOSTRANDO, e não uma segunda consulta montada para o
// download. Duas origens para o mesmo número é como se descobre, meses depois, que o arquivo e a
// tela discordam. Aqui não há como: é o mesmo dado, serializado.
//
// ⚠️ JSON, e não CSV. A tela tem quebras aninhadas (por assunto, por critério, por lado, por dia),
// e achatar tudo numa tabela perde exatamente a estrutura que a IA usaria para cruzar. Onde o
// clube quer planilha, a planilha já existe: é o caso da lista de respostas do CSAT.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { downloadJsonFile } from 'dashboard/helper/downloadHelper';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  // Nome curto da tela, entra no nome do arquivo.
  nome: { type: String, required: true },
  dados: { type: [Object, Array], default: null },
  // Unix timestamps do período mostrado. Vão dentro do arquivo: sem isso, o arquivo não diz de
  // que semana ele é, e a pergunta seguinte à IA já nasce sem resposta.
  since: { type: Number, default: null },
  until: { type: Number, default: null },
});

const { t } = useI18n();

// ⚠️ "TEM DADOS" É CONTEÚDO, NÃO CHAVE (03/10). Vários painéis guardam o estado num `reactive`
// já com o esqueleto montado (`{ total: 0, indicadores: {}, serie_diaria: [] }`), então contar
// chaves dava "tem dados" ANTES de a consulta voltar: o botão aparecia pronto na primeira pintura
// e quem clicasse baixava o esqueleto. Foi o que a Tamara relatou em 02/10, "o arquivo fica
// vazio" · o arquivo não estava vazio, estava com o estado inicial da tela dentro.
//
// Período sem nenhum movimento também cai aqui, e está certo: não há o que exportar.
const temConteudo = valor => {
  if (valor === null || valor === undefined || valor === '') return false;
  if (Array.isArray(valor)) return valor.some(temConteudo);
  if (typeof valor === 'object') return Object.values(valor).some(temConteudo);
  if (typeof valor === 'number') return valor !== 0;
  return true;
};

const temDados = computed(() => temConteudo(props.dados));

const baixar = () => {
  const agora = new Date();
  const carimbo = agora.toISOString().slice(0, 10);
  downloadJsonFile(`fandata-${props.nome}-${carimbo}.json`, {
    relatorio: props.nome,
    periodo: {
      desde: props.since ? new Date(props.since * 1000).toISOString() : null,
      ate: props.until ? new Date(props.until * 1000).toISOString() : null,
    },
    gerado_em: agora.toISOString(),
    dados: props.dados,
  });
};

defineExpose({ baixar });
</script>

<template>
  <Button
    v-if="temDados"
    sm
    slate
    faded
    icon="i-ph-download-simple"
    :label="t('RELATORIO_EXPORTAR.BOTAO')"
    :title="t('RELATORIO_EXPORTAR.DICA')"
    @click="baixar"
  />
</template>
